'use client';

import { useQuery } from '@tanstack/react-query';
import { fetchCodeReviewRepos } from '@/apis/codeReviewRepos';

/**
 * Repositories the Code Review repo filter can offer for this org.
 *
 * Shared by the Overview and Review Analytics tabs so both offer an identical
 * list. Long staleTime because the set of repos with review data changes on the
 * order of days, not page views.
 */
export function useCodeReviewRepos(orgUuid: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['codeReviewRepos', orgUuid] as const,
    queryFn: async () => {
      if (!orgUuid) throw new Error('Missing org');
      return await fetchCodeReviewRepos({ OrgUUID: orgUuid });
    },
    enabled: Boolean(orgUuid) && enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
    throwOnError: false,
  });
}
